import {render} from 'react-dom'
import App from './components/App'
import './styles/style.scss'

render(<App/>, document.getElementById('root'))